var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ob1-popin-modal2",
    { attrs: { id: _vm.modalId, "aria-labelledby": _vm.modalId + "-label" } },
    [
      _c("p", {
        staticClass: "h4",
        attrs: { id: _vm.modalId + "-label" },
        domProps: { innerHTML: _vm._s(_vm.energyLabel.popinTitle) },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "w-50",
        attrs: { alt: "", src: _vm.energyLabel.labelImage },
      }),
      _vm._v(" "),
      _vm.energyLabel.sheetUrl
        ? _c("ob1-liens", {
            attrs: {
              "with-arrow": true,
              "is-large": true,
              text: _vm.energyLabel.sheetLinkLabel,
              href: _vm.sheetHref,
              target: "_blank",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }